/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_User_IdsInputs */

const en_dialog_user_ids = /** @type {(inputs: Dialog_User_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User IDs`)
};

const es_dialog_user_ids = /** @type {(inputs: Dialog_User_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDs de usuario`)
};

/**
* | output |
* | --- |
* | "User IDs" |
*
* @param {Dialog_User_IdsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_user_ids = /** @type {((inputs?: Dialog_User_IdsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_User_IdsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_user_ids(inputs)
	return en_dialog_user_ids(inputs)
});